import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
// import Frame1 from "assets/images/frame-1.png";
// import Frame2 from "assets/images/frame-2.png";
import IntelligentPortfolioImage from "assets/blog_main_images/IntelligentPortfolioBuilder.jpeg";
import RentalImage from "assets/blog_main_images/earn-rent-without-200000.jpeg";
import howToInvest from "assets/blog_main_images/how-to-invest-in-stocks.jpeg";
import "../../Blog/BlogMainLanding.css";

const BlogSection = ({ showHeader = true }) => (
  <section id="blog-section-read-more">
    <Container className="mt-5">
      <Row className="gap-4 gap-lg-0">
        {showHeader && (
          <Col sm={12} className="text-center mb-2 mb-lg-4">
            {/*<h3 className="mb-3">Blog</h3>*/}
            <h2>Read more:</h2>
          </Col>
        )}
        <Col sm={12} lg={4}>
          <a
            className="card-title-blog"
            href="https://fortinves.tech/blog/how-to-invest-in-stocks"
          >
            <Card className="white-card border-0 mx-auto mb-4 h-100">
              <Card.Img variant="top" src={howToInvest} />
              <Card.Body className="d-flex flex-column justify-content-between">
                <div>
                  <Card.Title>
                    <h3>How to start investing in stocks?</h3>
                  </Card.Title>
                  <Card.Text>
                    Starting an investment in stocks is simple, quick and
                    secure. Read about why it is secure, how to start.
                  </Card.Text>
                </div>
                <footer className="mt-4">
                  <h5 style={{ fontWeight: "lighter", display: "inline-flex" }}>
                    <a href="https://fortinves.tech/blog/how-to-invest-in-stocks">
                      Read more
                      <i
                        className="bi bi-arrow-right-circle mt-4"
                        style={{ fontSize: "1.2rem", marginLeft: "5px" }}
                      ></i>
                    </a>
                  </h5>
                </footer>
              </Card.Body>
            </Card>
          </a>
        </Col>
        <Col sm={12} lg={4}>
          <a
            className="card-title-blog"
            href="https://fortinves.tech/blog/covered-call"
          >
            <Card className="white-card border-0 mx-auto mb-4 h-100">
              <Card.Img variant="top" src={RentalImage} />
              <Card.Body className="d-flex flex-column justify-content-between">
                <div>
                  <Card.Title>
                    <h3>Rental Income Without $200,000</h3>
                  </Card.Title>
                  <Card.Text>
                    Ever wondered if you can make some rental income with a
                    100$. Stocks call them dividends. Simplified explanation.
                  </Card.Text>
                </div>
                <footer className="mt-4">
                  <h5 style={{ fontWeight: "lighter", display: "inline-flex" }}>
                    <a href="https://fortinves.tech/blog/covered-call">
                      Read more
                      <i
                        className="bi bi-arrow-right-circle mt-4"
                        style={{ fontSize: "1.2rem", marginLeft: "5px" }}
                      ></i>
                    </a>
                  </h5>
                </footer>
              </Card.Body>
            </Card>
          </a>
        </Col>
        <Col sm={12} lg={4}>
          <a
            className="card-title-blog"
            href="https://fortinves.tech/blog/smart-portfolio-builder"
          >
            <Card className="white-card border-0 mx-auto mb-4 h-100">
              <Card.Img variant="top" src={IntelligentPortfolioImage} />
              <Card.Body className="d-flex flex-column justify-content-between">
                <div>
                  <Card.Title>
                    <h3>Smart Portfolio Builder</h3>
                  </Card.Title>
                  <Card.Text>
                    Explore how to make a portfolio in the most intelligent way
                    possible.
                  </Card.Text>
                </div>
                <footer className="mt-4">
                  <h5 style={{ fontWeight: "lighter", display: "inline-flex" }}>
                    <a href="https://fortinves.tech/blog/smart-portfolio-builder">
                      Read more
                      <i
                        className="bi bi-arrow-right-circle mt-4"
                        style={{ fontSize: "1.2rem", marginLeft: "5px" }}
                      ></i>
                    </a>
                  </h5>
                </footer>
              </Card.Body>
            </Card>
          </a>
        </Col>
      </Row>
    </Container>
  </section>
);

export default BlogSection;
